import { SLOT } from '@/admins/SmartReports/components/Layouts/types';
import {
  SmartReportComponentTypesEnum,
  SmartReportLayoutIdsEnum,
} from '@/admins/SmartReports/types';
import { BaseRowEdit, BaseRowThumbnail, BaseRowView } from './BaseRowLayout';

const layout = [
  [SLOT, SLOT],
  [SLOT, SLOT],
  [SLOT, SLOT],
  [SLOT, SLOT],
];

const rootStyles = {
  display: 'grid',
  padding: '0.5rem 0.5rem 2.5rem 0.5rem',
  gap: '0.5rem',
  gridTemplateColumns: '1fr 1fr',
  gridTemplateRows: '75px 1fr 0.5fr 1fr 1fr',
  '& > :first-of-type': {
    gridColumn: '1 / 3',
  },
  '& > *': {
    minHeight: 0,
    minWidth: 0,
    overflow: 'auto',
  },
};

const rootThumbnail = {
  ...rootStyles,
  padding: '0.2rem',
  gap: '0.1rem',
  gridTemplateRows: '10px 1fr 0.5fr 1fr 1fr',
};

const ComponentView = props => <BaseRowView layout={layout} rootStyles={rootStyles} {...props} />;

const ComponentEdit = () => <BaseRowEdit layout={layout} rootStyles={rootStyles} />;

const ComponentThumbnail = props => (
  <BaseRowThumbnail layout={layout} rootStyles={rootThumbnail} {...props} />
);

export const FourRowEightSlotLayout = {
  id: SmartReportLayoutIdsEnum.FourRowEightSlots,
  title: 'Four Row Eight Slot Layout',
  description:
    'A layout with title, two columns, half-height middle row, and two more rows of two columns.',
  Thumbnail: ComponentThumbnail,
  Component: ComponentEdit,
  ComponentView,
  elementTypes: Object.values(SmartReportComponentTypesEnum),
};
